import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSlidesView = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.79 3.694C4.79 2.758 5.52 2 6.42 2H17.58c.9 0 1.628.758 1.628 1.694v16.612c0 .936-.729 1.694-1.628 1.694H6.42c-.9 0-1.628-.758-1.628-1.694zm1.629-.242a.237.237 0 0 0-.233.242v16.612c0 .134.104.242.233.242H17.58a.237.237 0 0 0 .233-.242V3.694a.237.237 0 0 0-.233-.242zM2.698 5.797c.385 0 .697.325.697.726v9.954c0 .4-.312.726-.697.726-.386 0-.698-.325-.698-.726V6.523c0-.4.312-.726.698-.726m18.604 0c.386 0 .698.325.698.726v9.954c0 .4-.312.726-.698.726s-.697-.325-.697-.726V6.523c0-.4.312-.726.697-.726"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSlidesView;
